export const CACHE_KEYS = {
  SUPPORT_DEPARTMENT_STATUS: 'supportDepartmentStatus',
};
